<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import VipBenefitSection2 from "./vip-benefit-section-2.svelte";
</script>

<VipBenefitSection2
	title={$t(Verbiage.vip_alt2_referral_bonus)}
	description={$t(Verbiage.vip_alt2_referral_description)}
	image={cfgToThemeCdnPath('/about-vip/benefit-2.png')}
/>
